import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { People as PeopleIcon } from '@mui/icons-material';
import Avatar from 'react-avatar';
import * as dates from '@simplybenefits/sb-dates';
import { Text, Theme, CardBlock } from '@simplybenefits/sb-ui-library';
import { styled } from '@mui/system';

const StyledCardBlockBottom = styled('div')(({ theme }) => ({
    display: 'flex',
    height: 'auto',
    minHeight: '20px',
    paddingTop: '5px',
    width: '100%',
    [theme.breakpoints.down('500')]: {
        justifyContent: 'space-between'
    }
}));

const StyledCardBlockLeft = styled('div')(({ theme }) => ({
    display: 'flex',
    height: '100%',
    lineHeight: '30px',
    textAlign: 'left',
    verticalAlign: 'middle',
    width: '70%',
    [theme.breakpoints.down('500')]: {
        width: 'unset'
    }
}));

const StyledCardBlockRight = styled('div')(({ theme }) => ({
    display: 'inline',
    height: '100%',
    lineHeight: '30px',
    textAlign: 'right',
    verticalAlign: 'middle',
    width: '30%',
    [theme.breakpoints.down('500')]: {
        width: '100%'
    }
}));

const StyledCardBlockTop = styled('div')(({ theme }) => ({
    borderBottom: `1px solid ${ Theme.colors.lightGrey }`,
    display: 'flex',
    height: 'auto',
    minHeight: '65px',
    width: '100%',
    [theme.breakpoints.down('500')]: {
        flexWrap: 'wrap'
    }
}));

class AdvisorCard extends PureComponent {
    render() {
        const { advisor, id, testid } = this.props;
        const styles = {
            cardBlockAvatar: {
                display: 'inline',
                height: '100%',
                paddingRight: '20px',
                width: '60px'
            },
            cardBlockLeftBody: {
                display: 'inline',
                height: '100%'
            }
        };

        return (
            <CardBlock
                id={id || testid}
                onClick={this.props.onClick || null}
            >
                <StyledCardBlockTop>
                    <StyledCardBlockLeft>
                        <div style={styles.cardBlockAvatar}>
                            <Avatar
                                name={advisor.company}
                                size="50"
                                textSizeRatio={2.2}
                                round={true}
                                fgColor={Theme.colors.skyBlue}
                                color={Theme.colors.lightBlue}
                            />
                        </div>

                        <div style={styles.cardBlockLeftBody}>
                            <Text
                                large
                                display="block"
                            >
                                {advisor.company}
                            </Text>
                            <Text
                                medium
                                display="inline"
                            >
                                {advisor.email}
                            </Text>
                        </div>
                    </StyledCardBlockLeft>

                    <StyledCardBlockRight>
                        <Text
                            color={Theme.colors.brandGreen}
                            align="right"
                            mediumLarge
                            display="block"
                        >
                            Active
                        </Text>

                        <Text
                            color={Theme.colors.darkGrey}
                            align="right"
                            small
                            display="block"
                        >
                            Brokerage: { advisor.brokerage }
                        </Text>
                    </StyledCardBlockRight>
                </StyledCardBlockTop>

                <StyledCardBlockBottom
                    style={{
                        color: Theme.colors.darkGrey
                    }}
                >
                    <StyledCardBlockLeft>
                        <Text
                            color="inherit"
                            medium
                            display="block"
                        >
                            <PeopleIcon />{advisor.numAccounts}
                        </Text>
                    </StyledCardBlockLeft>

                    <StyledCardBlockRight
                        style={{
                            color: Theme.colors.darkGrey
                        }}
                    >
                        <Text
                            color="inherit"
                            tiny
                            display="inline"
                        >
                            CREATED:{' '}{dates.getLocalDisplay(advisor.dateAdded, 'lll')}
                        </Text>
                    </StyledCardBlockRight>
                </StyledCardBlockBottom>
            </CardBlock>
        );
    }
}

export default (connect()(AdvisorCard));